var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lodging.userNotifications.length || _vm.lodging.histories.length)?_c('div',[(_vm.toggleIconsAssistance)?[_vm._l((_vm.lodging.histories),function(history,index){return _c('span',{key:`asiin${index}`},[(
					_vm.filterPerDay({
						dayTable: _vm.dayTable,
						history: history.in,
						type: 'asi',
					})
				)?_c('v-icon',{staticClass:"ifTodayQuestion",style:({
					'background-color': 'orange',
				}),attrs:{"dark":"","small":""}},[_vm._v(" mdi-arrow-up ")]):_vm._e()],1)}),_vm._l((_vm.lodging.histories),function(history,index){return _c('span',{key:`asiout${index}`},[(
					_vm.filterPerDay({
						dayTable: _vm.dayTable,
						history: history.out,
						type: 'asi',
					})
				)?_c('v-icon',{staticClass:"ifTodayQuestion",style:({
					'background-color': '#03d02f',
				}),attrs:{"dark":"","small":""}},[_vm._v(" mdi-arrow-down ")]):_vm._e()],1)})]:[_vm._l((_vm.getNotifications(_vm.lodging.userNotifications, 'sms')),function(notification,index){return _c('span',{key:`sms${index}`},[(
					_vm.filterPerDay({
						type: 'noti',
						dayTable: _vm.dayTable,
						notification,
					})
				)?_c('v-icon',{staticClass:"ifTodayQuestion",style:({
					'background-color': _vm.getStatusColor(notification),
				}),attrs:{"dark":"","dense":"","small":""}},[_vm._v(" mdi-account-question ")]):_vm._e()],1)}),_vm._l((_vm.getNotifications(_vm.lodging.userNotifications, 'gps')),function(notification,key){return _c('span',{key:`gps${key}`},[(
					_vm.filterPerDay({
						type: 'noti',
						dayTable: _vm.dayTable,
						notification,
					})
				)?_c('v-icon',{staticClass:"ifTodayQuestion",style:({
					'background-color': _vm.getStatusColor(notification),
				}),attrs:{"dark":"","dense":"","small":""}},[_vm._v(" mdi-crosshairs-gps ")]):_vm._e()],1)}),_vm._l((_vm.getNotifications(
				_vm.lodging.userNotifications,
				'client'
			)),function(notification,index){return _c('span',{key:`client${index}`},[(
					_vm.filterPerDay({
						type: 'noti',
						dayTable: _vm.dayTable,
						notification,
					})
				)?_c('v-icon',{staticClass:"ifTodayQuestion",style:({
					'background-color': _vm.getStatusColor(notification),
				}),attrs:{"dark":"","dense":"","small":""}},[_vm._v(" mdi-gmail ")]):_vm._e()],1)})]],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }